import styled, { keyframes } from 'styled-components';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 10;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    top: 30%;
    visibility: visible;
    animation: ${appearFromTop} 0.4s;

		// 650px
    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  top: -500px;
  position: fixed;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 5px;
  width: auto;
  height: auto;
  padding: 20px 40px;
  visibility: hidden;
  transition: all 0.5s ease-out;

  h1 {
    font-weight: 500;
  }
  h2 {
    margin-left: 10px;
    color: #455a64;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		width: 97%;
		padding: 10px 15px 20px;
	}
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 20px;
    font-weight: 500;
    margin: 10px 0 20px;
  }

  .cupom {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 7px;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);

    .cupom-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 20px 10px;

      div {
        display: flex;
        align-items: center;

        svg {
          font-size: 24px;
          margin-right: 10px;
        }

        span {
          font-size: 20px;
        }
      }
    }
    .cupom-dates {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px 10px;

      div {
        display: flex;
        flex-direction: column;
        justify-content: center;

        button {
          background-color: transparent;
          border: none;
          font-size: 14px;
          font-weight: 600;
          color: #2196f3;
        }

        span.label {
          font-size: 13px;
          color: #607d8b;
        }
        span {
          font-size: 14px;
          color: #37474f;
        }
      }
      div.fim {
        align-items: flex-end;
      }
    }
  }
`;

export const ContentView = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px 0 20px;

  h2 {
    font-size: 18px;
    font-weight: 500;
  }
`;

export const ButtonsView = styled.div`
  display: flex;

  button:first-child {
    margin-right: 10px;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		button {
			padding: 5px 30px;
		}
	}
`;
